import { render, staticRenderFns } from "./Carousel-Werte.vue?vue&type=template&id=28c22c8c"
import script from "./Carousel-Werte.vue?vue&type=script&lang=js"
export * from "./Carousel-Werte.vue?vue&type=script&lang=js"
import style0 from "./Carousel-Werte.vue?vue&type=style&index=0&id=28c22c8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports